module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/1_631a284425e67a8ca482c0e184843191.png";